import React, { useEffect, useState } from "react";
import "./LandingGoToTop.css";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const GoToTop = () => {
  const [showButton, setShowButton] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      const progress = (scrollTop / scrollHeight) * 100;

      setScrollProgress(progress);

      if (scrollTop > window.innerHeight) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const radius = 30;
  const circumference = 2 * Math.PI * radius;
  const dashOffset = circumference - (scrollProgress / 100) * circumference;

  return (
    <React.Fragment>
      {showButton && (
        <button className="floating-action-button" onClick={scrollToTop}>
          <svg className="progress-ring" width="70" height="70">
            <circle
              className="progress-ring__circle"
              stroke="#007bff"
              strokeWidth="4"
              fill="transparent"
              r={radius}
              cx="35"
              cy="35"
              style={{
                strokeDasharray: `${circumference} ${circumference}`,
                strokeDashoffset: dashOffset,
              }}
            />
          </svg>
          <FontAwesomeIcon icon={faArrowUp} className="arrow-icon" />
        </button>
      )}
    </React.Fragment>
  );
};

export default GoToTop;
